function capitalizeWord(str: null | undefined): null | undefined;
function capitalizeWord(str: string): string;
function capitalizeWord(str: Maybe<string>): Maybe<string> {
  return str ? `${str.charAt(0).toUpperCase()}${str.slice(1).toLowerCase()}` : str;
}

export { capitalizeWord };

export const stripUrlProtocol = (url: string) => url.replace(/(^\w+:|^)\/\//, '');

export const generateSlugFromTitle = (title: string): string => {
  return title
    .toLowerCase()
    .trim()
    .replace(/[\s]+/g, '-')
    .replace(/[^\w\-]+/g, '')
    .replace(/--+/g, '-')
    .replace(/^-+|-+$/g, '');
};

export const formatCamelCase = (str: string): string => {
  // Split on capital letters and trim any extra spaces
  const words = str.replace(/([A-Z])/g, ' $1').trim();
  // Capitalize first letter of the entire string
  return words.charAt(0).toUpperCase() + words.slice(1);
};
